import { render } from "./payslip-reports-filter.vue?vue&type=template&id=38349fb8"
import script from "./payslip-reports-filter.vue?vue&type=script&lang=js"
export * from "./payslip-reports-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__